import PermissionEdit from './PermissionEdit';

export default PermissionEdit;
